import React from 'react';
import { oneOf } from 'prop-types';

const Alert = ({ type, children }) => {
  return (
    <div className={`alert alert-${type} mt-1 mb-3`} role='alert'>
      <strong>{children}</strong>
    </div>
  );
};

Alert.propTypes = {
  type: oneOf('primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'),
};

export default Alert;
